import { useRef } from 'react';
import type { SocialVideoPresentation } from '../../../renderer/src/social-presentation';
import type { NumeralKind } from '../render/metric-numerals';
import { MetricNumerals } from './MetricNumerals';
import { useStatisticFit } from './use-statistic-fit';

interface Properties {
  label: string; value: string; total: string; kind: NumeralKind;
  unit?: string | undefined; totalLabel?: string;
  presentation: SocialVideoPresentation;
}

/** Fits the complete value inside its column while retaining the selected size when space permits. */
export function SocialStatistic({ label, value, total, kind, unit, totalLabel = 'of', presentation }: Properties) {
  const valueRef = useRef<HTMLElement>(null);
  useStatisticFit(valueRef, 18 / presentation.statisticsSize);
  return <div className="social-stat" data-composition-element={`${label} statistics`}>
    <dt>{label}</dt>
    <dd ref={valueRef}><span className="statistic-reading"><MetricNumerals value={value} kind={kind} />{unit && <span className="social-stat-unit">{unit}</span>}</span></dd>
    {presentation.showTotals && <small>{totalLabel} <MetricNumerals value={total} kind={kind} />{unit && ` ${unit}`}</small>}
  </div>;
}
